module.exports = __webpack_public_path__ + "img/11.728699eb.png";